<template>
  <t-dialog
    :visible="visible"
    header="修改密码"
    placement="center"
    width="500"
    :confirm-btn="{
      content: '提交',
      theme: 'primary',
      loading,
    }"
    :cancel-btn="{
      content: '关闭',
    }"
    :on-confirm="handleSubmit"
    :on-close="handleClose"
  >
    <t-form ref="form" :data="formData" colon :rules="rules" reset-type="initial">
      <t-form-item label="手机号" name="phone">
        <t-input v-model="formData.phone" readonly disabled />
      </t-form-item>
      <t-form-item label="验证码" name="verificationCode">
        <t-input v-model="formData.verificationCode" theme="normal" placeholder="请输入验证码" maxlength="6" />
        <t-button theme="primary" :disabled="countDown > 0" @click="sendCode">
          {{ countDown == 0 ? '发送验证码' : `${countDown}秒后可重发` }}
        </t-button>
      </t-form-item>
      <t-form-item label="新密码" name="newPassword">
        <t-input v-model="formData.newPassword" type="password" placeholder="请输入新密码" />
      </t-form-item>
    </t-form>
  </t-dialog>
</template>
<script setup>
import { MessagePlugin } from 'tdesign-vue-next';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

import { getVerificationCode, userUpdatePassword } from '@/api/login';
import { useCounter } from '@/hooks';
import { useUserStore } from '@/store';

const router = useRouter();
const [countDown, handleCounter] = useCounter();

// 用户store
const userStore = useUserStore();

// 加载状态
const loading = ref(false);

// 弹窗状态
const visible = ref(false);
const handleDialog = () => {
  visible.value = true;
  formData.value.phone = userStore.userInfo.phone;
};

// 表单数据
const form = ref(null);
const formData = ref({
  phone: userStore.userInfo.phone,
  verificationCode: '',
  newPassword: '',
});

// 校验规则
const rules = ref({
  verificationCode: [{ required: true, message: '请输入验证码' }],
  newPassword: [
    { required: true, message: '请输入密码' },
    { min: 6, max: 20, message: '密码长度应为6-20位' },
    { pattern: /^[a-zA-Z0-9]+$/, message: '密码只能包含字母和数字' },
  ],
});

// 发送验证码
const sendCode = async () => {
  // 验证手机号
  if (!formData.value.phone) {
    MessagePlugin.error('请输入手机号');
    return;
  }
  const { code } = await getVerificationCode({ phone: formData.value.phone });
  if (code === 200) {
    handleCounter();
  }
};

// 提交
const handleSubmit = () => {
  form.value.validate().then(async (e) => {
    if (e === true) {
      loading.value = true;
      try {
        const { code, msg } = await userUpdatePassword(formData.value);
        if (code === 200) {
          MessagePlugin.success(msg);
          // 退出登录
          await userStore.logout();
          router.push('/login');
        }
      } catch (e) {
        console.log(e);
      } finally {
        loading.value = false;
      }
    }
  });
};

// 关闭弹窗
const handleClose = () => {
  visible.value = false;
  form.value.reset();
};

// 暴露
defineExpose({
  handleDialog,
});
</script>
<style lang="less" scoped></style>
